var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccShops(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Shopping",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7801",
    "data-name": "Rectangle 7801",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32304",
    "data-name": "Group 32304",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34473",
    "data-name": "Path 34473",
    d: "M22.448,2.017H4.2C3.412,9.648,2.694,17.27,1.842,24.9c7.766.067,15.531.067,23.287.067v-.01c-.919-7.622-1.771-15.32-2.681-22.942M19.709,7.724a1.412,1.412,0,0,1-.488.594V9.744A6.028,6.028,0,0,1,13.2,15.767h-.067a5.21,5.21,0,0,1-.546-.029,5.9,5.9,0,0,1-.594-.1c-.105-.019-.211-.048-.316-.077a6.022,6.022,0,0,1-4.5-5.822V8.327A1.577,1.577,0,1,1,9.56,7.733a1.5,1.5,0,0,1-.709.728V9.744a4.347,4.347,0,1,0,8.694,0V8.461a1.572,1.572,0,0,1,1.379-2.825,1.573,1.573,0,0,1,.785,2.087",
    transform: "translate(0.516 0.509)",
    fill: "#b3b6c6"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccShops);
export default __webpack_public_path__ + "static/media/mcc_shops.e7739a5773817bed22863a437af14082.svg";
export { ForwardRef as ReactComponent };